<template>
  <div class="container_">
    <div
      class="item_image"
      @click="handlePlay()"
      @mouseover="handleIsHover()"
      @mouseleave="handleIsHoverOut()"
    >
      <img
        :src="placeholder_image"
        alt="item"
        :data-src="getImageSrc()"
      />
      <div class="item__overlay">
        <i
          class="fas fa-play"
          @mouseover="handleIsHover()"
          @mouseleave="handleIsHoverOut()"
        ></i>
      </div>
      <div
        class="item__overlay_time"
        v-if="!liveStatus()"
      >
        {{ getDuration() }}
      </div>

      <div
        class="item__overlay_live"
        v-if="liveStatus()"
      >
        <!-- <i class="fas fa-circle"></i> -->
        <span class="live-icon"></span>
        Live
      </div>
    </div>

    <div class="item__details">
      <div
        class="artist_profile"
        @click.prevent="handleGetArtist()"
      >
        <img
          :src="placeholder_image"
          :data-src="getArtistImage()"
          alt="artist"
        />
        <i class="fas fa-badge-check"></i>
      </div>
      <div class="item__description">
        <h3
          :class="{ title_hoved: isHover, title: true }"
          @click.prevent="handlePlay()"
        >
          {{ item.title }}
        </h3>
        <span
          class="item_artsts_name"
          @click.prevent="handleGetArtist()"
          ><i class="fas fa-user"></i> &nbsp; {{ getArtistName() }}</span
        >
        <span class="item_views"
        v-if="!liveStatus() && item?.unique_views_count > 0"
          ><i class="fas fa-eye"></i> &nbsp; {{ item?.unique_views_count }} views</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'single_item',
  props: [
    'item',
    'type',
    'default_image',
    'episode_portrait_path',
    'episode_landscape_path',
    'item_portrait_path',
    'item_landscape_path',
    'artist_path',
    'placeholder_image',
    'is_live',
  ],
  data() {
    return {
      isHover: false,
    };
  },
  mounted(){
  },
  methods: {
    getImageSrc() {
      if (this.item.image?.landscape) {
        return this.type === 'episode'
          ? this.item.image?.landscape == null
            ? this.default_image
            : this.episode_landscape_path + this.item.image?.landscape
          : this.item_landscape_path + this.item.image.landscape;
      } else {
        return this.default_image;
      }
    },

    getArtistImage() {
      if (this.type === 'episode') {
        return this.item.item?.creator?.image == null
          ? this.default_image
          : this.artist_path + '/' + this.item.item?.creator?.image;
      }
      return this.item.creator?.image == null
        ? this.default_image
        : this.artist_path + '/'+ this.item.creator?.image;
    },

    getArtistName() {
      return this.type === 'episode'
        ? this.item.item?.creator?.name
        : this.item.creator?.name;
    },
    getDuration() {
      if (this.item?.video?.duration != null) {
        return this.item?.video?.duration;
      }
      return '00:00';
    },

    handlePlay() {
      var url = '';
      if (this.type === 'episode') {
        const item =
          this.item?.item?.slug !== null
            ? this.item?.item?.slug
            : this.item?.item?.id;
        const episode =
          this.item?.episode_slug !== null
            ? this.item?.episode_slug
            : this.item?.id;
        url = `/watch-video/${item}/${episode}`;
      } else if (this.isLive) {
        const item = this.item?.slug !== null ? this.item?.slug : this.item?.id;
        url = `/live-shows/${item}`;
      } else {
        const item = this.item?.slug !== null ? this.item?.slug : this.item?.id;
        url = `/watch-video/${item}`;
      }

      window.location.href = url;
    },

    handleGetArtist() {
      var url = '';
      if (this.type === 'episode') {
        const creator =
          this.item.item?.creator?.slug !== null
            ? this.item.item?.creator?.slug
            : this.item.item?.creator?.id;
        url = `/creators/${creator}`;
      } else {
        const creator =
          this.item.creator?.slug !== null
            ? this.item.creator?.slug
            : this.item.creator?.id;
        url = `/creators/${creator}`;
      }

      window.location.href = url;
    },

    liveStatus() {
      return this.is_live ? true : false;
    },
    handleIsHover() {
      this.isHover = true;
    },
    handleIsHoverOut() {
      this.isHover = false;
    },
  },
};
</script>

<style scoped>
.container_ {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
  flex-direction: column;
  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: 100%;
}
.container_ .item_image {
  width: 100%;
  height: 150px;
  margin: 0;
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;

  &:hover {
    cursor: pointer;
  }
  &:hover img {
    transform: scale(1.1);
    transition: transform 0.5s;
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--color-secondary-site);
    z-index: 1;
    border-radius: 10px;
    transition: all 0.5s;
    opacity: 0;
    transform: scale(1.1);
    visibility: hidden;
    z-index: 0;
  }
  &:hover::after {
    transition: all 0.5s;
    visibility: visible;
    bottom: auto;
    top: 0;
    opacity: 0.3;
  }

  &:hover .item__overlay {
    opacity: 1;
    transition: opacity 0.5s;
  }
  &:hover .item__overlay_time {
    opacity: 0;
    transition: opacity 0.5s;
  }

  &:hover .item__overlay_live {
    opacity: 0;
    transition: opacity 0.5s;
  }

  &:hover ~ .item__description .title {
    color: var(--color-primary-site);
  }
}

.container_ .item_image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item__details {
  display: grid;
  grid-template-columns: 40px 1fr;
  justify-content: flex-start;

  align-items: center;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  margin-top: 10px;
}
.artist_profile {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;

  &:hover {
    cursor: pointer;
  }
}

.artist_profile img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.artist_profile i {
  position: absolute;
  bottom: 2px;
  right: 4px;
  color: white;
  padding: 2px;
  border-radius: 50%;
  font-size: 0.7rem;
}
.item__description {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 10px;
}
.title {
  font-size: 0.8rem;
  font-weight: bold;
  text-transform: capitalize;
  text-align: left;
  &:hover {
    cursor: pointer;
  }
}
.item_artsts_name {
  font-size: 0.7rem;
  color: #8b8b8b;
  padding: 0;
  line-height: 2.5;

  &:hover {
    cursor: pointer;
  }
}
.item_views {
  font-size: 0.7rem;
  color: #8b8b8b;
  padding: 0;
  line-height: 2.5;
}

.item__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2rem;
  opacity: 0;
  transition: opacity 0.5s;
  z-index: 1;
}
.item__overlay_time {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 1px 7px;
  border-radius: 5px;
  margin: 10px;
  font-size: 0.8rem;
  z-index: 1;
  line-height: 1.8;
}
.item__overlay_live {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(190, 0, 0, 0.9);
  color: white;
  padding: 1px 8px;
  border-radius: 5px;
  margin: 10px;
  font-size: 0.8rem;
  z-index: 1;
  line-height: 1.8;

}
.title_hoved {
  color: var(--color-secondary-site);
}

.item__overlay_live .live-icon {
  display: inline-block;
  position: relative;
  top: 50%;
  background-color: rgb(255, 255, 255);
  width: 5px;
  height: 5px;
  margin-left: 0px;
  border-radius: 50%;
  z-index: 1;
  display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
}

.item__overlay_live .live-icon:before {
  content: '';
  display: block;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.628);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: live 2s ease-in-out infinite;
  z-index: -1;
}

@keyframes live {
  0% {
    transform: scale(1, 1);
  }

  100% {
    transform: scale(3.5, 3.5);
    background-color: rgba(rgb(255,255,255), 0);
  }
}

</style>
